export const COUNTRIES = ["GHANA", "USA", "NIGERIA", "MAURITIUS", "CANADA"];
export const PAYMENT_TYPE = [
  "Direct deposit",
  "Bank Transfer",
  "Mobile Transfer",
];
export const DISTRIBUTION = ["BALANCE", "PERCENTAGE"];
export const CURRENCIES = {
  USA: "USD",
  GHANA: "GHS",
  NIGERIA: "NGN",
  MAURITIUS: "MUR",
  CANADA: "CAD",
};


export const DISTRIBUTION_TYPES = {
  BALANCE: "BALANCE",
  PERCENTAGE: "PERCENTAGE",
}